export default "__VITE_ASSET__DWkbjto___"